﻿import { IEditor } from "../interface/editor";
import { ValidatorError } from "../types/validator-error";
import { ValidatorFn } from "../types/validator-fn";
import { ValidatorParam } from "../interface/validator-param";
import { isValidatorDisabled } from "./is-validator-disabled";


export interface lengthValidatorParam extends ValidatorParam {
    minLength?: number;
    minLengthMessage?: string|null;
    maxLength?: number;
    maxLengthMessage?: string|null;
}

export function lengthValidator(param: lengthValidatorParam): ValidatorFn {

    return (editor: IEditor): ValidatorError | null => {
        if (isValidatorDisabled(param, editor)) {
            return null;
        }

        let message='Validate Failed';
        if(param.message) {
            message= param.message;
        }

        let result: ValidatorError | null = null;
        if (param.minLength && !isNaN(param.minLength) && param.minLength > 0) {
            if (editor.value !== undefined && editor.value != null && editor.value.length >= param.minLength) {
                result = null;
            } else {
                result = { message: param.minLengthMessage?? message };
            }
        }
        if (result == null) {
            if (param.maxLength && !isNaN(param.maxLength) && param.maxLength > 0) {
                if (editor.value === undefined || editor.value == null || editor.value.length <= param.maxLength) {
                    result = null;
                } else {
                    result = { message: param.maxLengthMessage ?? message };
                }
            }
        }

        return result;
    };
}
